
import classes from './TimelinePromo.module.scss';
import React, { useEffect, useRef}  from 'react';
import globalJson from 'data/content.json';
import { getFileName } from 'helpers/FileCaching';
import ScrollMagic from 'scrollmagic';
import TimelineMax from "gsap/TimelineMax";
import { TweenMax, Power3} from 'gsap';
const layoutImages = require.context('assets/images/global/layout', true, /.*\.(gif|png|jpe?g|svg)$/i);

const TimelinePromo = (props) => {
    const titles = ['6th millenium bc', '4th millenium bc', '1st millenium bc', '2nd century bc', '1st cen'];
    let container = useRef()

    //Configure scroll magic
    let scrollMagicController = useRef(new ScrollMagic.Controller())
    let scrollMagicScene = useRef(new ScrollMagic.Scene({
                                    triggerHook:0.7
                                }).addTo(scrollMagicController.current)
                            )
    
    //TimelineGraphic variables
    let timelineGraphic_tl = useRef(new TimelineMax({paused:true}));
    timelineGraphic_tl.current.timeScale(2);

    let timelineBar = useRef()
    let ovalFirst = useRef()
    let ovalOutFirst= useRef()
    let oval = useRef()
    let ovalOut = useRef()
    let item = useRef()
    
    let innerWidth = window.innerWidth;

    const configureScrollMagic = () => {

        scrollMagicScene.current.triggerElement(timelineBar.current);
        scrollMagicScene.current.duration((container.current.clientHeight));
        scrollMagicScene.current.triggerHook(0.7);
        // scrollMagicScene.current.triggerHook(1);
        scrollMagicScene.current.on("progress", function(event){
            updateTimeline(event.progress);
        })

    }

    const createTimeline = () => {
   
        TweenMax.set([timelineBar.current],{width:0,opacity:0, transformOrigin:"left"})
        TweenMax.set([ovalOut.current, oval.current, ovalFirst.current, ovalOutFirst.current], {opacity:0})
        // TweenMax.set(['.titlesItemSpan_0', 'titlesItemSpan_1', 'titlesItemSpan_2', '.titlesItemSpan_3','.titlesItemSpan_4'], {opacity:0})
     
        timelineGraphic_tl.current.fromTo(container.current, 1.2, {opacity:0, y:90}, { delay: 0, opacity:1, y:0, ease: Power3.easeOut});
        timelineGraphic_tl.current.fromTo(ovalFirst.current, 0.1, {opacity:0, scale:0.5}, { delay: 1, opacity:1, scale:1, ease: Power3.easeInOut});
        timelineGraphic_tl.current.to(ovalFirst.current, 0.1, {scale:1, ease: Power3.easeInOut})
        timelineGraphic_tl.current.fromTo(ovalOutFirst.current, 0.1, {opacity:0, scale:1}, { delay: -0.3, opacity:1, scale:1.6, ease: Power3.easeInOut});
        timelineGraphic_tl.current.to(ovalOutFirst.current, 0.1, {scale:1, ease: Power3.easeInOut})

        if(innerWidth < 992){
            timelineGraphic_tl.current.fromTo(timelineBar.current, 0.5, {opacity:0, width:'0%'}, {opacity:1, width:'67%', ease: Power3.easeOut});
            timelineGraphic_tl.current.fromTo('.ovalItem_0', 0.3, {opacity:0, scale:0.5}, { delay: -0.1, opacity:1, scale:1, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalItem_0', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.ovalOutItem_0', 0.3, {opacity:0, scale:1}, { delay: -0.3, opacity:1, scale:1.6, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalOutItem_0', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.titlesItemSpan_0', 0.3 , {opacity:0}, {delay: -0.2, opacity:1, ease: Power3.easeOut});
            timelineGraphic_tl.current.fromTo(timelineBar.current, 0.5, {width:'67%'}, {width:'100%', ease: Power3.easeOut});
            
        }else if(innerWidth >= 992){
            timelineGraphic_tl.current.fromTo(timelineBar.current, 0.5 , {opacity:0, width:'0%'}, {opacity:1, width:'18%', ease: Power3.easeOut});
            timelineGraphic_tl.current.fromTo('.ovalItem_0', 0.3, {opacity:0, scale:0.5}, { delay: -0.1, opacity:1, scale:1, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalItem_0', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.ovalOutItem_0', 0.3, {opacity:0, scale:1}, { delay: -0.3, opacity:1, scale:1.6, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalOutItem_0', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.titlesItemSpan_0', 0.3 , {opacity:0}, {delay: -0.2, opacity:1, ease: Power3.easeOut});

            timelineGraphic_tl.current.fromTo(timelineBar.current, 0.5, {width:'18%'}, {width:'37%', ease: Power3.easeOut});
            timelineGraphic_tl.current.fromTo('.ovalItem_1', 0.3, {opacity:0, scale:0.5}, { delay: -0.1, opacity:1, scale:1, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalItem_1', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.ovalOutItem_1', 0.3, {opacity:0, scale:1}, { delay: -0.3, opacity:1, scale:1.6, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalOutItem_1', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.titlesItemSpan_1', 0.3 , {opacity:0}, {delay: -0.2, opacity:1, ease: Power3.easeOut});

            timelineGraphic_tl.current.fromTo(timelineBar.current, 0.5, {width:'37%'}, {width:'62%', ease: Power3.easeOut});
            timelineGraphic_tl.current.fromTo('.ovalItem_2', 0.3, {opacity:0, scale:0.5}, { delay: -0.1, opacity:1, scale:1, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalItem_2', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.ovalOutItem_2', 0.3, {opacity:0, scale:1}, { delay: -0.3, opacity:1, scale:1.6, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalOutItem_2', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.titlesItemSpan_2', 0.3 , {opacity:0}, {delay: -0.2, opacity:1, ease: Power3.easeOut});
            
            timelineGraphic_tl.current.fromTo(timelineBar.current, 0.5, {width:'62%'}, {width:'83%', ease: Power3.easeOut});
            timelineGraphic_tl.current.fromTo('.ovalItem_3', 0.3, {opacity:0, scale:0.5}, { delay: -0.1, opacity:1, scale:1, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalItem_3', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.ovalOutItem_3', 0.3, {opacity:0, scale:1}, { delay: -0.3, opacity:1, scale:1.6, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalOutItem_3', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.titlesItemSpan_3', 0.3 , {opacity:0}, {delay: -0.2, opacity:1, ease: Power3.easeOut});

            timelineGraphic_tl.current.fromTo(timelineBar.current, 0.5,  {width:'83%'}, {width:'100%', ease: Power3.easeOut});
            timelineGraphic_tl.current.fromTo('.ovalItem_4', 0.3, {opacity:0, scale:0.5}, { delay: -0.1, opacity:1, scale:1, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalItem_4', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.ovalOutItem_4', 0.3, {opacity:0, scale:1}, { delay: -0.3, opacity:1, scale:1.6, ease: Power3.easeInOut});
            timelineGraphic_tl.current.to('.ovalOutItem_4', 0.3, {scale:1, ease: Power3.easeInOut})
            timelineGraphic_tl.current.fromTo('.titlesItemSpan_4', 0.3 , {opacity:0}, {delay: -0.2, opacity:1, ease: Power3.easeOut});
            
        }
     
    }

    const updateTimeline = (progress) => {
        let timelineLength = timelineGraphic_tl.current.duration();
        let tweenToSeconds = timelineLength*progress
        timelineGraphic_tl.current.tweenTo(tweenToSeconds);
    }

    function onExploreClick(event){
        window.gtag('event', "Explore button clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': "Explore button clicked "+ event.currentTarget.href,
			'value':10
          });
        
    }

    useEffect(() => {
        createTimeline();
        configureScrollMagic();
    });


    // useEffect(() => {
    //     const getDynamicHeight = () => {

    //     }
    //     getDynamicHeight();
        
    // }, []);

    return (
        <div className={classes.TimelinePromo}>
            <div className={classes.TimelinePromo__container}>
                <div ref={container}  className={classes.TimelinePromo__wrapforAnim}>
                    <div className={classes.TimelinePromo__animation}>
                        <div className={classes.TimelinePromo__barWrapper}>
                            <div ref={timelineBar} className={classes.TimelinePromo__bar}></div>
                            <img ref={ovalFirst} className={`${classes.TimelinePromo__oval} ${classes.TimelinePromo__ovalFirst}`} alt="" src={getFileName(layoutImages, 'oval.svg')} />
                            <img ref={ovalOutFirst} className={`${classes.TimelinePromo__ovalOut} ${classes.TimelinePromo__ovalOutFirst}`}  alt="" src={getFileName(layoutImages, 'oval_out.svg')} />
                        </div>
                        <div  className={classes.TimelinePromo__titlesWrapper}>
                            <ul className={classes.TimelinePromo__titles}>
                                {titles.map((value, index) => {
                                    return <li ref={item} className={`${classes.TimelinePromo__titlesItem} titlesItem_${index}`} key={index}>
                                                <span className={`titlesItemSpan_${index} titlesItemSpan`}>{value}</span>
                                                <img ref={oval} className={`${classes.TimelinePromo__oval} ${classes.TimelinePromo__ovalItem} ovalItem_${index}`} alt="" src={getFileName(layoutImages, 'oval.svg')} />
                                                <img ref={ovalOut} className={`${classes.TimelinePromo__ovalOut} ${classes.TimelinePromo__ovalOutItem} ovalOutItem_${index}`}  alt="" src={getFileName(layoutImages, 'oval_out.svg')} />
                                            </li>
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className={`container`}>
                        <div className={classes.TimelinePromo__contentContainer}>
                            <h2 dangerouslySetInnerHTML={{__html:globalJson.timelinePromo.title}}></h2>
                            <p className={classes.TimelinePromo__description} >{globalJson.timelinePromo.description}</p>
                            <a className={`main_btn ${classes.TimelinePromo__link}`} onClick={onExploreClick} href={globalJson.timelinePromo.link.url} rel="noopener noreferrer">{globalJson.timelinePromo.link.title}</a>
                        </div>
                    </div>
                </div>
            
                <div className={classes.TimelinePromo__bg}></div>
            </div> 
          
        </div>
    )
};
export default TimelinePromo;